import request from '@/utils/request'

// 查询设备列表列表
export function listDeviceStock (query) {
  return request({
    url: '/mibo/device-stock/list',
    method: 'get',
    params: query
  })
}

// 查询设备列表分页
export function pageDeviceStock (query) {
  return request({
    url: '/mibo/device-stock/page',
    method: 'get',
    params: query
  })
}

// 查询设备列表详细
export function getDeviceStock (data) {
  return request({
    url: '/mibo/device-stock/detail',
    method: 'get',
    params: data
  })
}

// 新增设备列表
export function addDeviceStock (data) {
  return request({
    url: '/mibo/device-stock/add',
    method: 'post',
    data: data
  })
}

// 修改设备列表
export function updateDeviceStock (data) {
  return request({
    url: '/mibo/device-stock/edit',
    method: 'post',
    data: data
  })
}

// 删除设备列表
export function delDeviceStock (data) {
  return request({
    url: '/mibo/device-stock/delete',
    method: 'post',
    data: data
  })
}

// 导入设备列表
export function importDeviceStock (data) {
  return request({
    url: '/mibo/device-stock/importData',
    method: 'post',
    data: data
  })
}
